














import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import Teacher from '../../../api/v2/models/teacher';

@Component({})
export default class TeacherView extends Vue {

  @Prop({
      required: true
    })
    teacher: Teacher
}
